import React from 'react';
import { useRouter } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export const useOrderStatusNavigation = () => {
  const router = useRouter();

  // ─────────────────────────────────────────────────────────────────────

  const navigateToOrderStatusScreen = React.useCallback(
    (orderId: string) => {
      router.navigate({
        pathname: '/order-status/[orderId]',
        params: { orderId },
      });
    },
    [router],
  );

  const navigateToRateOrderScreen = React.useCallback(
    (orderId: string) => {
      router.navigate({
        pathname: '/feedback/[orderId]',
        params: { orderId },
      });
    },
    [router],
  );

  // ─────────────────────────────────────────────────────────────────────

  return {
    navigateToOrderStatusScreen,
    navigateToRateOrderScreen,
  };
};
